<template>
  <div class="form-action-btns" :class="{ reversed }">
    <SubmitBtn :isLoading="isLoading" :disabled="disabled">
      <slot />
    </SubmitBtn>
    <button type="button" @click="$emit('cancel')">
      Отмена
    </button>
  </div>
</template>

<script lang="ts" src="./FormActionBtns.ts"></script>

<style scoped lang="scss" src="./FormActionBtns.scss"></style>
